import React from 'react';

function useForceUpdate() {
  const [value, setValue] = React.useState(0);
  return () => setValue(value => value + 1); // update state to force render
}

export default useForceUpdate;

// escape hatch for scenarios where you can't control the state of a component (i.e. a third party component)
